import { type ComponentProps, type FC, type ReactNode } from 'react';

import styles from './LegalDocument.module.css';

/** Типографика документа без шапки — для текста в модальном окне */
export const LegalProse: FC<ComponentProps<'div'>> = ({ className, ...props }) => (
  <div {...props} className={[styles.prose, className].filter(Boolean).join(' ')} />
);

interface LegalDocumentProps {
  title: string;
  children: ReactNode;
}

/** Оформление юридических текстов: политика, согласие — длинное чтение узкой колонкой */
export const LegalDocument: FC<LegalDocumentProps> = ({ title, children }) => (
  <article className={`${styles.prose} ${styles.root}`}>
    <div className={styles.badge}>Документы</div>
    <h1 className={styles.title}>{title}</h1>
    {children}
  </article>
);
